import type { SVGProps } from 'react'
const SvgSyBnb = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 141.7 141.7" width={24} height={24} {...props}>
		<path d="M26 70.9v26.3l22.4 13.2v15.4L13 105V63.2zm0-26.4v15.3l-13-7.7V36.8l13-7.7 13.1 7.7zm31.8-7.7 13-7.7 13.1 7.7-13.1 7.7z" />
		<path d="M35.5 91.7V76.3l13 7.7v15.3zm22.3 24.2 13 7.7 13.1-7.7v15.3l-13.1 7.7-13-7.7zm44.8-79.1 13-7.7 13.1 7.7v15.3l-13.1 7.7V44.5zm13 60.4V70.9l13.1-7.7V105l-35.4 20.8v-15.4l22.4-13.2z" />
		<path d="m106.3 91.7-13 7.7V84l13-7.7z" />
		<path d="M106.3 50v15.4L83.9 78.6V105l-13 7.6-13-7.6V78.6L35.5 65.4V50l13.1-7.7 22.3 13.2 22.4-13.2 13.1 7.7zM35.5 23.7 70.8 2.8l35.4 20.9-13 7.7-22.4-13.2-22.4 13.2-13-7.7z" />
	</svg>
)
export default SvgSyBnb
